import { classNames } from "../../../utils/classNames";
import React, { FC } from "react";
import DocumentTitle from "react-document-title";
import { RouteComponentProps } from "react-router-dom";
import { FontIcon } from "react-toolbox/lib/font_icon";

import style from "./style.scss";

export interface PricingStateProps { }

export interface PricingDispatchProps { }

export interface PricingOwnProps extends RouteComponentProps<any> { }

export type PricingProps = PricingStateProps & PricingDispatchProps & PricingOwnProps;

const PricingLivestream: FC<PricingProps> = () => {
    const __SUPPORT_EMAIL__ = window?.xaStudioConfig?.supportEmail;

    return (
        <DocumentTitle title="XAPP | Podcast Pricing">
            <div className={style.pagebg}>
                <header className={style.header}>
                    <h2>Pricing</h2>
                </header>

                <div className={style.planwrap}>
                    <div className={style.plancontainer}>
                        <div className={style.planheader}>
                            <h2>Podcast Lite</h2>
                            <p>Coming Soon</p>
                        </div>
                        <div className={style.plandetails}>
                            <ul className={style.blurred}>
                                <li>We are still working out the particluars</li>
                                <li>But please trust, that this is going to be great</li>
                                <li>And please check back soon</li>
                            </ul>
                        </div>
                    </div>

                    <div className={classNames(style.plancontainer, style.recommended)}>
                        <div className={classNames(style.planheader, style.pro)}>
                            <h2>Podcast</h2>
                            <p>$29.99 setup fee</p>
                            <p>$29.99/month</p>

                            <div className={style.value}>
                                <FontIcon value="stars" className={style.valueicon} />
                                <small>Best Value</small>
                            </div>
                        </div>
                        <div className={style.plandetails}>
                            <ul>
                                <li>Custom welcome message which can include sponsorship</li>
                                <li>Streamlined invocation to make show faster to access</li>
                                <li>Listener picks up where they left off previous session</li>
                                <li>
                                    Podcaster can choose if listener is prompted about latest episode or would like to
                                    resume previous
                                </li>
                                <li>User can listen on both Android and iOS through Alexa app</li>
                                <li>Alexa dashboard analytics</li>
                                <li>Email and phone support for podcaster and email support for listeners</li>
                                <li>New features coming each month</li>
                            </ul>
                        </div>
                    </div>

                    <div className={style.plancontainer}>
                        <div className={style.planheader}>
                            <h2>Podcast Pro</h2>
                            <p>Coming soon</p>
                        </div>
                        <div className={style.plandetails}>
                            <ul className={style.blurred}>
                                <li>
                                    Similar to the Podcast Lite plan, we don't have the exact details worked out quite
                                    yet
                                </li>
                                <li>
                                    But the Podcast Pro plan is going to be the premier way to publish podcast apps at
                                    scale.
                                </li>
                                <li>And we are very excited about it</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <footer className={style.footer}>
                    <p>
                        If you are an existing Voice Radio Pro subscriber, you qualify for a Podcast subscription for
                        $19.99/month with no setup fee.
                    </p>
                    <p>
                        If you have any questions or are interested in changing your current subscription, please don't
                        hesitate to <a href={`mailto:${__SUPPORT_EMAIL__}`}>contact us</a>.
                    </p>
                </footer>
            </div>
        </DocumentTitle>
    );
};

export default PricingLivestream;
